const enumValue = description => Object.freeze({toString: () => description});

export const PLATE = enumValue('PLATE');
export const DOCUMENT_ID = enumValue('DOCUMENT_ID');
export const HITS = enumValue('HITS');
export const DOSSIE_ID = enumValue('DOSSIE_ID')
export const NO_SORT = enumValue('');